/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateProfileRequest interface.
 */
export function instanceOfUpdateProfileRequest(_value) {
    return true;
}
export function UpdateProfileRequestFromJSON(json) {
    return UpdateProfileRequestFromJSONTyped(json, false);
}
export function UpdateProfileRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
    };
}
export function UpdateProfileRequestToJSON(json) {
    return UpdateProfileRequestToJSONTyped(json, false);
}
export function UpdateProfileRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
    };
}
